import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for Redstone Arsenal contractors with TDY orders",
      "Perfect for NASA Marshall engineers flying to JAXA/ESA",
      "Great for UAH students with study abroad programs",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Huntsville post offices",
      "Good for planned international trips from HSV",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Huntsville or Madison USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — ~150 mi, 2.5 hrs drive",
      "NPIC appointment required before traveling to Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function HuntsvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Huntsville"
      introText="Huntsville travelers — Redstone Arsenal contractors with TDY orders to Germany, NASA Marshall engineers collaborating with JAXA in Japan and ESA in Europe, UAH students with research exchanges and Space Camp international programs, and Tennessee Valley families heading to Cancun — have several options for getting a passport fast. Here is how they compare, and why most North Alabama residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Atlanta."
      options={options}
      emergencyDescription="Huntsville does not have its own regional passport agency. The closest is Atlanta — about 150 miles southeast, a 2.5+ hour drive through Chattanooga on I-59/I-75. For a Redstone contractor with a Monday TDY to Stuttgart who finds out on Thursday, that round trip is brutal. I-565 to I-65 to I-59 construction adds unpredictable delays, and Huntsville International Airport has limited direct international service, so most travelers connect through Atlanta or Nashville anyway."
      disclaimerText="*Processing speed depends on eligibility and documentation. Huntsville does not have a regional passport agency — the closest is Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}